import React, { useEffect, lazy, Suspense } from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import SoulversityHero from '@/components/soulversity/SoulversityHero';
import TwoPillarsSection from '@/components/soulversity/TwoPillarsSection';
import LearnPreviewSection from '@/components/soulversity/LearnPreviewSection';
import ExpertsOnlineSection from '@/components/ExpertsOnlineSection';
import { Skeleton } from '@/components/ui/skeleton';

const TestimonialsSection = lazy(() => import('@/components/TestimonialsSection'));

const SectionLoadingFallback = () => (
  <div className="w-full py-12">
    <div className="container">
      <Skeleton className="w-full h-8 mb-4 rounded-lg" />
      <Skeleton className="w-3/4 h-4 mb-8 rounded-lg" />
    </div>
  </div>
);

const SoulversityLanding: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col home-page">
      <Navbar />
      <main className="flex-1">
        <SoulversityHero />
        <TwoPillarsSection />
        <ExpertsOnlineSection />
        <LearnPreviewSection />
        <Suspense fallback={<SectionLoadingFallback />}>
          <TestimonialsSection />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
};

export default SoulversityLanding;
